import { Assignment } from "@apaq/orgkit-js";

export class AssignmentHelper {
    public static divideMinutesAmongTasks(assignment: Assignment, minutes: number) {
        let total = AssignmentHelper.resolveTotalDuration(assignment);
        let diff = minutes - total;
        let percentageArray: number[] = [];

        assignment.tasks.forEach(t => {
            let percentage = t.duration / total;
            percentageArray.push(percentage);
        });

        let minutesLeft = minutes;
        for(let i=0;i<assignment.tasks.length;i++) {
            if(i < assignment.tasks.length - 1) {
                let percentage = percentageArray[i];
                let share = Math.round(minutes * percentage);
                minutesLeft -= share;
                assignment.tasks[i].duration = share;
            } else {
                assignment.tasks[i].duration = minutesLeft;
            }
        }
    }

    public static resolveTotalDuration(assignment: Assignment) {
        let total = 0;
        assignment.tasks.forEach(t => {
            total += t.duration;
        });
        return total;
    }

    public static resolveTotalAmount(assignment: Assignment) {
        let total = 0;
        assignment.tasks.forEach(t => {
            total += t.unitPrice * t.quantity;
        });
        return total;
    }
}